import { BodyM, Button, Heading2 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import { ConceptImage } from '@/components/ConceptImage'
import { useBottomSheet } from '@/context/BottomSheetContext'
import { useDevice } from '@/context/Device'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { suggestedPriorityWrapper } from './index.css'

export const SuggestedPriorityHelp: React.FC = () => {
  const { t } = useTranslation()
  const device = useDevice()
  const { closeBottomSheet } = useBottomSheet()
  const { closeModal } = useModal()

  const handleCtaClick = () => {
    if (device === 'mobile') {
      closeBottomSheet()
    } else {
      closeModal()
    }
  }
  return (
    <>
      <div className={suggestedPriorityWrapper}>
        <Heading2 className={sprinkles({ marginBottom: '3xl' })}>
          {t('suggested:Suggested_Priority_HelpModal_Title')}
        </Heading2>
        <div className={sprinkles({ marginBottom: '2xl', textAlign: 'center' })}>
          <ConceptImage height={115} name={'home-love'} width={107} />
        </div>
        <BodyM className={sprinkles({ marginBottom: '2xl', paddingX: 'm' })}>
          {t('suggested:Suggested_Priority_HelpModal_Description')}
        </BodyM>
        <Button
          className={sprinkles({ marginBottom: 'm', marginX: 'auto' })}
          label={t('common:simple_confirm')}
          minWidth={167}
          styleVariant="secondary"
          onClick={handleCtaClick}
        />
      </div>
    </>
  )
}
